export enum PRIMARY_ACCOUNT_TYPE {
  WIDGET_USER = 'widgetUser',
  WEBSITE_OWNER = 'websiteOwner',
}
